import { all } from 'redux-saga/effects'
import getFarmersSaga from './getFarmersSaga'
import getProductsSaga from './getProductsSaga'
import getStatusChangeSaga from './getStatusChangeSaga'

export default function* rootSaga() {
    yield all([getFarmersSaga(), getProductsSaga(), getStatusChangeSaga()])
}
